import { reactive, readonly } from 'vue'
import { projectFirestore } from '@/firebase/config'

const state = reactive({
  bagData: null,
  storageData: null,
  mysteriousStorageData: null,
  loading: true,
  unsubscribers: []
})

const readonlyState = readonly(state)

let initialized = false

export function useInventoryStore () {
  const init = (userId) => {
    if (initialized || !userId) return
    initialized = true
    state.loading = true

    state.unsubscribers.push(
      projectFirestore.collection('bags').doc(userId).onSnapshot(
        (snap) => {
          state.bagData = snap.exists ? snap.data() : null
        },
        (err) => { console.error('useInventoryStore bags error:', err) }
      )
    )

    state.unsubscribers.push(
      projectFirestore.collection('storages').doc(userId).onSnapshot(
        (snap) => {
          state.storageData = snap.exists ? snap.data() : null
        },
        (err) => { console.error('useInventoryStore storages error:', err) }
      )
    )

    state.unsubscribers.push(
      projectFirestore.collection('mysteriousStorages').doc(userId).onSnapshot(
        (snap) => {
          state.mysteriousStorageData = snap.exists ? snap.data() : null
          state.loading = false
        },
        (err) => {
          console.error('useInventoryStore mysteriousStorages error:', err)
          state.loading = false
        }
      )
    )
  }

  const cleanup = () => {
    state.unsubscribers.forEach((fn) => { if (fn) fn() })
    state.unsubscribers = []
    initialized = false
    state.bagData = null
    state.storageData = null
    state.mysteriousStorageData = null
    state.loading = true
  }

  return {
    get bagData () { return readonlyState.bagData },
    get storageData () { return readonlyState.storageData },
    get mysteriousStorageData () { return readonlyState.mysteriousStorageData },
    get loading () { return readonlyState.loading },
    init,
    cleanup
  }
}
